/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  ExportTimesheetEntriesQueryResponse,
  ExportTimesheetEntriesQueryParams,
} from '../models/ExportTimesheetEntries.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { exportTimesheetEntriesQueryResponseSchema } from '../zod/exportTimesheetEntriesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const exportTimesheetEntriesQueryKey = (
  params: ExportTimesheetEntriesQueryParams,
) => [{ url: '/api/entries/export' }, ...(params ? [params] : [])] as const;

export type ExportTimesheetEntriesQueryKey = ReturnType<
  typeof exportTimesheetEntriesQueryKey
>;

/**
 * {@link /api/entries/export}
 */
export async function exportTimesheetEntries(
  params: ExportTimesheetEntriesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    ExportTimesheetEntriesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/entries/export`,
    params,
    ...requestConfig,
  });
  return exportTimesheetEntriesQueryResponseSchema.parse(res.data);
}

export function exportTimesheetEntriesQueryOptions(
  params: ExportTimesheetEntriesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = exportTimesheetEntriesQueryKey(params);
  return queryOptions<
    ExportTimesheetEntriesQueryResponse,
    ResponseErrorConfig<Error>,
    ExportTimesheetEntriesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return exportTimesheetEntries(params, config);
    },
  });
}

/**
 * {@link /api/entries/export}
 */
export function useExportTimesheetEntries<
  TData = ExportTimesheetEntriesQueryResponse,
  TQueryData = ExportTimesheetEntriesQueryResponse,
  TQueryKey extends QueryKey = ExportTimesheetEntriesQueryKey,
>(
  params: ExportTimesheetEntriesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ExportTimesheetEntriesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? exportTimesheetEntriesQueryKey(params);

  const query = useQuery(
    {
      ...exportTimesheetEntriesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
